<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />

            <div class="text-center">
              <img
                src="../../assets/img/icon/promo.svg"
                style="max-width: -webkit-fill-available"
              />
              <h5 class="custom-promo-title mt-4" style="color: #000a2c">
                20% OFF your first online class with Pickiddo
              </h5>
              <h6 class="custom-promo-text" style="color: #878787">
                Continue learning this holiday with the sweetest<br /> deal! With 30%
                OFF Credits, you can buy extra<br /> credit and make use of it to find
                and learn with<br /> your favourite tutor! take a boba tea break, and<br />
                grab another for dinner. Or simply order your<br /> favourite desserts
                to enjoy all day long, and<br /> repeat the next day! Valid until 30
                April 2022
              </h6>
            </div>
          </div>
        </div>
      </div>
    </CContainer>
    <div class="bottom-center">
      <CButton class="btn-select-blue mt-5">Use Promo Now</CButton>
    </div>
    <div class="header-top">Promotion</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" />
    </div>
    <div class="header-right">
      <img src="../../assets/img/icon/trash.svg" @click="OpenDelete()" />
    </div>
    <div style="clear: both"></div>
    <CModal size="md" :show.sync="DeleteNotification">
      <div class="text-center">
        <h3 class="custom-title-popup" style="color: #000a2c">
          Delete This Notification
        </h3>
        <br />
      </div>
      <div class="text-center">
        <h4 class="sub-title-header" style="color: #000a2c">
          Are you sure you want to clear all<br />
          notification?
        </h4>
        <br />
      </div>
      <div class="text-center">
        <CButton class="btn-select-blue mt-5">Yes, Delete Notification</CButton>
      </div>
    </CModal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      DeleteNotification: false,
    };
  },
  methods: {
    // GoToExam(){
    //   this.$router.push(
    //     "/RegisterStudentExam"
    //   );
    // }
    OpenDelete() {
      this.DeleteNotification = true;
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}

input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}

.class-teach-name {
  padding: 4px 1px;
  top: 45px;
  /* height: 40px; */

  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;

  /* Pure/White */

  color: #ffffff;

  /* Inside auto layout */

  /* flex: none;
  order: 0;
  flex-grow: 0; */
}
.custom-btn-add {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;

  color: #007cef;
}
.custom-promo-text{

font-family: 'Montserrat';
font-style: normal;
font-weight: 500;
font-size: 14px;
line-height: 150%;
align-items: center;

color: #000A2C;
}
.custom-promo-title{
font-family: 'Montserrat';
font-style: normal;
font-weight: 600;
font-size: 16px;
line-height: 29px;

color: #000A2C;
}
</style>